import { DatePicker } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import Select from "react-select";
import { submitEnclosureFiles } from "../../auth/services/privateapicalling";
import * as Yup from "yup";
import { toast,ToastContainer } from "react-toastify";
// import fileimage from "../../../public/assets/img/icons/file"

const ExperienceEdit: React.FC<any> = ({
  isOpen,
  onClose,
  selectedExperience,
  modalId,
  title,
  appId,
  listToUpdate,
  onChangeCallback,
  validationSchema,
}) => {
  const token = useSelector((state: any) => state.auth.token);

  const language = useSelector((state: any) => state.auth.language);
  const formLanguage = useSelector((state: any) => state.auth.formLanguage);

  const [editList, setEditList] = useState<any>({});

  const [formData, setFormData] = useState({
    projectName: "",
    projectAwardedby:"",
    startDate: "",
    endDate: "",
  });

  const [files, setFiles] = useState<{ [key: string]: File | null }>({});
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isValid, setIsValid] = useState<boolean | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [editLoading,setEditLoading] = useState(false)
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, files: selectedFiles } = e.target;
    if (selectedFiles && selectedFiles.length > 0) {
      setFiles((prevFiles) => ({
        ...prevFiles,
        [name]: selectedFiles[0],
      }));
    }
  };

  const validateForm = async () => {
    try {
      await validationSchema.validate(
        { ...formData, evidence: files.evidence },
        { abortEarly: false }
      );
      setErrors({});
      return true;
    } catch (err) {
      const validationErrors: any = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          if (error.path) {
            validationErrors[error.path] = error.message;
          }
        });
      }
      setErrors(validationErrors);
      return false;
    }
  };

  const handleUpdate = async () => {
    // const isValid = await validateForm();
    // if (!isValid) return;
    setEditLoading(true)
    
    if (
      files.evidence &&
      formData.projectName &&
      formData.projectAwardedby &&
      formData.startDate &&
      formData.endDate
    ) {
      const uploadData = new FormData();

      uploadData.append("file", files.evidence as Blob);
      uploadData.append(
        "documentName",
        selectedExperience.eveidenceProof.documentName
      );
      uploadData.append("applicationId", appId);

      const uploadDoc = await submitEnclosureFiles(
        uploadData,
        token,
        selectedExperience.eveidenceProof?.docId
      );
      if (uploadDoc.success == true) {
        toast.success(uploadDoc?.message)
        const eveidenceProof = {
          docId: uploadDoc.data.id,
          documentName: uploadDoc.data.documentName,
          fileName: uploadDoc.data.fileName,
        };

        
        const isDocIndex = listToUpdate.findIndex(
          (edu: any) =>
            edu.eveidenceProof.documentName === uploadDoc.data.documentName
        );


        const newData = {
          ...formData,
          eveidenceProof: eveidenceProof,
        };

     
        listToUpdate[isDocIndex] = { ...listToUpdate[isDocIndex], ...newData };

     
        onChangeCallback(listToUpdate);

        // Reset form and errors
        setFormData({ projectName: "",projectAwardedby:"", startDate: "", endDate: "" });
        setFiles({});
        setErrors({});

        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        setEditLoading(false)
      } else {
        setEditLoading(false)
        toast.error(`${uploadDoc.message}`);}
    } else {
      toast.error("Please fill all the fields");
      setEditLoading(false)

    }
  };

  useEffect(() => {

    if (selectedExperience && Object.keys(selectedExperience).length > 0) {
 
      setEditList(selectedExperience);
      setLoading(false);
    } else {
      setLoading(false);
    }
  
  }, [selectedExperience]);

  return (
    <>
      {isOpen && (
        <div
          className={`modal fade ${isOpen ? "show d-block" : ""}`}
          tabIndex={-1}
          aria-hidden={!isOpen}
          role=""
          style={{ overflow: "hidden" }}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg overflow-auto"
            onClick={onClose}
          >
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h4 className="modal-title">
                  {language.edit} {title}{" "}
                </h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  onClick={onClose}
                  // data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              {selectedExperience && (
                <div className="table-responsive w-80">
                  <table className="table table-bordered">
                    <thead className="table-light">
                      <tr>
                        <th>{language.project_name}</th>
                        <th>{language.project_awarded_by}</th>
                        <th>{language.attachements}</th>
                        <th>{language.start_date}</th>
                        <th>{language.end_date}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{selectedExperience.projectName}</td>
                        <td>{selectedExperience.projectAwardedby}</td>
                        <td>{selectedExperience.eveidenceProof.fileName}</td>
                        <td>{selectedExperience.startDate}</td>
                        <td>{selectedExperience.endDate}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
              <form>
                <div className="modal-body pb-0 ">
                  <div className="row">
                    <div className="mb-3">
                      <label className="form-label">
                        {formLanguage.project_name} ( {language.project_name}){" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="projectName"
                        value={formData.projectName}
                        onChange={handleInputChange}
                      />
                      {errors.projectName && (
                        <small className="text-danger">
                          {errors.projectName}
                        </small>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        {formLanguage.attested_copy} ({language.attested_copy}){" "}
                        <span className="text-danger">*</span>
                      </label>
                      <p className="text-danger mb-1">{language.file_type}</p>
                      <input
                        type="file"
                        className="form-control"
                        name="evidence"
                        accept=".pdf, .jpeg, .jpg"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                      />
                      {errors.evidence && (
                        <small className="text-danger">{errors.evidence}</small>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        {formLanguage.project_awarded_by} (
                        {language.project_awarded_by}){" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="projectAwardedby"
                        value={formData.projectAwardedby}
                        onChange={handleInputChange}
                      />
                      {errors.projectAwardedby && (
                        <small className="text-danger">
                          {errors.projectAwardedby}
                        </small>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        {formLanguage.start_date} ({language.start_date}){" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        name="startDate"
                        value={formData.startDate}
                        onChange={handleInputChange}
                        max={new Date().toISOString().split("T")[0]}
                      />
                      {errors.startDate && (
                        <small className="text-danger">
                          {errors.startDate}
                        </small>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        {formLanguage.end_date} ({language.end_date}){" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        name="endDate"
                        value={formData.endDate}
                        min={formData.startDate}
                        max={new Date().toISOString().split("T")[0]}
                        onChange={handleInputChange}
                      />
                      {errors.endDate && (
                        <small className="text-danger">{errors.endDate}</small>
                      )}
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    onClick={onClose}
                  >
                    {language.can}
                  </button>
                  <button
                   type="button" className="btn btn-primary" 
                    onClick={handleUpdate}
                    disabled={editLoading}
                  >
                         {editLoading ? (
                      <i className="ion-load-a ion-spin"></i> // Loading spinner
                    ) : (
                      `+ ${language.upd}`
                    )}
                    {/* {language.upd} */}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {isOpen && <div className="modal-backdrop fade show" onClick={onClose} />}
    </>
  );
};

export default ExperienceEdit;
